import * as React from 'react'

import { inject, observer } from 'mobx-react'

import NavBar from '~/client/src/desktop/components/NavBar/NavBar'
import { Resource } from '~/client/src/desktop/components/Resource'
import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import * as Layout from '~/client/src/shared/components/Layout'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import ProjectSetUp from '../ProjectSetUp/ProjectSetUp'
import { LocationsProvider } from './LocationsProvider'

interface LocationsProps {
  state?: DesktopInitialState
}

// List only, deliberately. Locations already have a map surface in ProjectSetUp that owns
// placement and geometry; a second map here would be a second place to edit the same
// artwork. The table is the part locations did not have.
const Locations: React.FC<LocationsProps> = ({ state }) => {
  const projectId = state?.activeProject?.id
  const userId = state?.user?.id

  if (!projectId || !userId || !state) {
    return null
  }

  return (
    <Layout.View className="locations">
      <Layout.Header className="layout-navigation">
        <NavBar />
      </Layout.Header>
      <Layout.Content className="tw:relative tw:overflow-hidden">
        <div className="tw:flex tw:items-center tw:h-full">
          <ProjectSetUp
            className="tw:flex tw:flex-col tw:h-full tw:max-w-fit"
            sidebarOnly
          />
          <div className="tw:flex tw:flex-1 tw:flex-col tw:h-full tw:min-w-0">
            <LocationsProvider
              projectId={projectId}
              userId={userId}
              state={state}
            >
              <Layout.View>
                <Layout.Header>
                  <Resource.TopBar>
                    <Resource.SavedViews projectId={projectId} />
                  </Resource.TopBar>
                  <Resource.Header>
                    <Resource.Search />
                    <Resource.Separator />
                    <Resource.Filters />
                    <Resource.Actions>
                      <Resource.DisplayOptions />
                    </Resource.Actions>
                  </Resource.Header>
                </Layout.Header>
                <Layout.Content>
                  <Resource.Content>
                    <Resource.ActionBar>
                      <div className="tw:flex tw:items-center tw:gap-2">
                        <Resource.CollapseToggle />
                        <Resource.RecordCount
                          label={c => Localization.translator.xLocations(c)}
                        />
                        <Resource.DeleteButton
                          confirmationLabel={c =>
                            Localization.translator.confirmDeletionOfLocations(
                              c,
                            )
                          }
                        />
                        <Resource.BulkEditButton />
                      </div>
                      <Resource.CreateButton />
                    </Resource.ActionBar>
                    <Resource.Table />
                  </Resource.Content>
                </Layout.Content>
              </Layout.View>
              <Resource.EditPanel />
              <Resource.BulkEditPanel />
            </LocationsProvider>
          </div>
        </div>
      </Layout.Content>
      <Layout.Footer>
        <div />
      </Layout.Footer>
    </Layout.View>
  )
}

export default inject('state')(observer(Locations))
